import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-2" }
const _hoisted_2 = { class: "fw-bold text-capitalize-first" }
const _hoisted_3 = {
  key: 0,
  class: "d-block text-muted"
}
const _hoisted_4 = { class: "d-flex align-items-center gap-3" }
const _hoisted_5 = { class: "text-muted small text-nowrap" }
const _hoisted_6 = { class: "card-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "card-header d-flex justify-content-between align-items-center gap-3",
      role: "button",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggle')))
    }, [
      _createElementVNode("div", null, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.title), 1),
        (_ctx.subtitle)
          ? (_openBlock(), _createElementBlock("small", _hoisted_3, _toDisplayString(_ctx.subtitle), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.$slots.actions)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
            }, [
              _renderSlot(_ctx.$slots, "actions")
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_5, [
          (_ctx.count !== null)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.count), 1)
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("i", {
            class: _normalizeClass(["fa ms-2", _ctx.open ? 'fa-chevron-up' : 'fa-chevron-down'])
          }, null, 2)
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_6, [
      _renderSlot(_ctx.$slots, "default")
    ], 512), [
      [_vShow, _ctx.open]
    ])
  ]))
}